import React, { useEffect, useState } from 'react';
import { FileTextIcon } from 'lucide-react';
import { getSupabaseErrorMessage, loadPublicSettings } from '../data/repository';
export function Terms() {
  const [termsText, setTermsText] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    void loadPublicSettings().then(settings => setTermsText(settings.termsText)).catch(loadError => setError(getSupabaseErrorMessage(loadError)));
  }, []);
  return <div className="min-h-screen bg-background py-12" data-id="element-776" data-mp="ga4b0tlb3df3">
      <div className="max-w-4xl mx-auto px-4" data-id="element-777" data-mp="g8t5opc7pxlv">
        <header className="text-center mb-12" data-id="element-778" data-mp="l97fabtgpfm0">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary" data-id="element-779" data-mp="laij2bmwqnd4">
            <FileTextIcon size={32} data-id="element-780" data-mp="q7ip4mjrbq48" />
          </span>
          <h1 className="mt-5 text-4xl font-display font-bold text-gray-900" data-id="element-781" data-mp="2n1direk8j6p4">
            Uvjeti najma
          </h1>
          <p className="mt-3 text-xl text-gray-600" data-id="element-782" data-mp="2s0gda52l9uiu">
            Pravila i uvjeti korištenja naše opreme
          </p>
        </header>
        <section className="rounded-3xl border border-gray-100 bg-white p-7 md:p-10" data-id="element-783" data-mp="23bftzam03lav">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-784" data-mp="1yhbmmq8tpb99">Opći uvjeti</h2>
          {error ? <p role="alert" className="mt-5 rounded-xl bg-red-50 p-4 text-red-800" data-id="element-785" data-mp="1tjtakqziefx1">
              {error}
            </p> : termsText ? <p className="mt-6 whitespace-pre-line leading-8 text-gray-700" data-id="element-786" data-mp="2m7p4jnxp1tq4">
              {termsText}
            </p> : <p className="mt-6 text-gray-600" data-id="element-787" data-mp="2d7ite8pgx5u4">
              Uvjeti najma bit će dostupni uskoro.
            </p>}
          <p className="mt-8 rounded-2xl bg-primary/10 p-5 font-medium text-gray-800" data-id="element-788" data-mp="288z7g8avju1r">
            Uvjeti specifični za pojedini proizvod dostupni su na stranici tog
            proizvoda pod gumbom „Uvjeti korištenja”.
          </p>
        </section>
      </div>
    </div>;
}